// Откуда редактор ОБЯЗАН читать курс: черновик, если он есть, иначе живой курс. Одно
// правило на чтение курса (`readEditorCourse`), гейт редактора и переезд источника.
import { moderationApi } from '../moderationApi'
import type { ModerationSelectState } from './refetchCourseModeration'

/** Чистая форма от уже прочитанного состояния модерации. */
export const expectedReadIdFrom = (
  modState: { draftId: number | null } | undefined,
  liveId: number,
): number => modState?.draftId ?? liveId

/**
 * Ожидаемый источник по кешу `/moderation` — БЕЗ подписки (опрос ведёт один
 * `ModerationPoller`). Кеша нет — живой id.
 */
export const expectedReadIdOf = (state: ModerationSelectState, liveId: number): number =>
  expectedReadIdFrom(moderationApi.endpoints.getCourseModeration.select(liveId)(state).data, liveId)
